export const awsConfig = {
  UserPoolId: "ap-northeast-1_eHQZg9j3e",
  UserPoolClientId: "livpjhal03m21mpd9e29bihfb",
  ServiceEndpoint: "https://05obmy0ye3.execute-api.ap-northeast-1.amazonaws.com/stg"
};
